import Vue from "vue"
import { mapState } from "vuex"

export const state = function () {
  return {
    display: false,
    locked: false,
    submission: null,
    current_set: [],
    animation_direction: 0,
  }
}

export const mutations = {
  HIDE: function (state) {
    state.display = false
  },
  SHOW: function (state) {
    state.display = true
  },
  LOCK: function (state) {
    state.locked = true
  },
  UNLOCK: function (state) {
    state.locked = false
  },
  SET_ANIMATION_DIRECTION: function (state, direction) {
    if (direction < 0) state.animation_direction = -1
    else if (direction > 0) state.animation_direction = 1
    else state.animation_direction = 0
  },
  SET_CURRENT_SET: function (state, set) {
    Vue.set(state, "current_set", [...set])
  },
  SET_INSPECTED_SUBMISSION: function (state, submission) {
    Vue.set(state, "submission", submission)
  },
}

export const actions = {
  GET_NEXT_RELEVANT_SUBMISSION_FROM_SUBMISSION: async function (
    { state, dispatch, commit, getters },
    submission
  ) {
    commit("SET_ANIMATION_DIRECTION", getters.current_set_position > 0 ? -1 : 1)
    return Vue.nextTick(async () => {
      const currentSet = state.current_set

      if (currentSet.length > 0)
        return await dispatch("INSPECT_SUBMISSION", currentSet[0].id)
      else {
        commit("SET_INSPECTED_SUBMISSION", null)
        commit("HIDE")
      }
    })
  },
  GET_NEXT_STANDART_SUB: function ({ dispatch, state, getters, commit }) {
    commit("SET_ANIMATION_DIRECTION", 1)
    Vue.nextTick(() => {
      if (getters.has_next)
        dispatch(
          "INSPECT_SUBMISSION",
          state.current_set[getters.current_set_position + 1].id
        )
    })
  },
  GET_PREVIOUS_STANDART_SUB: function ({ dispatch, state, getters, commit }) {
    commit("SET_ANIMATION_DIRECTION", -1)
    Vue.nextTick(() => {
      if (getters.has_previous)
        dispatch(
          "INSPECT_SUBMISSION",
          state.current_set[getters.current_set_position - 1].id
        )
    })
  },
  INSPECT_SUBMISSION: async function ({ commit, state }, submission_id) {
    if (state.locked === false) {
      commit("LOCK")

      try {
        const submission = await this.$axios.$get(
          "/submission/dashboard/" + submission_id + "/"
        )

        if (submission.status_history && submission.status_history.length)
          submission.status_history = JSON.parse(submission.status_history)
        commit("SET_INSPECTED_SUBMISSION", submission)
        commit("UNLOCK")
        commit("SHOW")
      } catch (error) {
        console.error(error)
      }
    }
  },
}

export const getters = {
  current_set_position: function (state, getters) {
    const set = state.current_set

    if (set && state.submission)
      return set.findIndex((elem) => {
        return elem.id === state.submission.id
      })
    else return -1
  },
  has_next: function (state, getters) {
    const set = state.current_set

    if (set)
      return (
        state.current_set.length > getters.current_set_position + 1 &&
        getters.current_set_position >= 0
      )
    else return false
  },
  has_previous: function (state, getters) {
    return getters.current_set_position > 0
  },
  submissions_by_status: function (state, getters, rootState) {
    return rootState.influencer_dashboard.submissions_by_status
  },
}
